import type { PriceOverrideSort, PriceOverrideStatus, SortOrder } from "@classes-service-types/index";
import {
  PriceOverrideSort as PriceOverrideSortOptions,
  SortOrder as SortOrderOptions,
} from "@classes-service-types/index";
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

export const useSortFilters = () => {
  const route = useRoute();
  const router = useRouter();

  const sortBy = ref<PriceOverrideSort>(PriceOverrideSortOptions.Id);
  const sortOrder = ref<SortOrder>(SortOrderOptions.Asc);

  watch(
    () => route.query,
    async (newParams, oldParams) => {
      if (newParams !== oldParams) {
        if (!newParams.sortBy) {
          sortBy.value = PriceOverrideSortOptions.Id;
        } else if (newParams.sortBy !== sortBy.value) {
          sortBy.value = newParams.sortBy as PriceOverrideSort;
        }

        if (!newParams.sortOrder) {
          sortOrder.value = SortOrderOptions.Asc;
        } else if (newParams.sortOrder !== sortOrder.value) {
          sortOrder.value = newParams.sortOrder as SortOrder;
        }
      }
    },
    { immediate: true },
  );

  const updateSortBy = async (updatedSortBy: PriceOverrideSort) => {
    sortBy.value = updatedSortBy;
    await router.push({ query: { ...route.query, sortBy: updatedSortBy } });
  };

  const updateSortOrder = async (updatedSortOrder: SortOrder) => {
    sortOrder.value = updatedSortOrder;
    await router.push({ query: { ...route.query, sortOrder: updatedSortOrder } });
  };

  return {
    sortBy,
    updateSortBy,
    sortOrder,
    updateSortOrder,
  };
};
